<template>
  <div class="external-confirmation-section">
    <p class="external-confirmation-section__title">{{ title }}</p>
    <p v-if="message" class="external-confirmation-section__message" v-html="message" />
    <ul v-if="links.length > 0" class="external-confirmation-section__list">
      <li v-for="(link, index) in links" :key="index" class="external-confirmation-section__item">
        <atom-link
          :url="link.url"
          :linkText="link.name"
          :imgPath="require('@/assets/img/icon/icon_external_link_black.svg')"
          linkColor="black80"
          class="external-confirmation-section__itemLink"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import AtomLink from '@/components/atoms/AtomLink.vue'

export type ExternalLinkType = {
  name: string
  url: string
}

/**
 * アプリでは表示できない場合の案内テキスト セクション
 */
export default defineComponent({
  name: 'ExternalConfirmationSection',
  components: { AtomLink },
  props: {
    /**
     * タイトル
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * 本文
     */
    message: {
      type: String,
      default: '',
    },
    /**
     * 遷移先情報
     */
    links: {
      type: Array as PropType<Array<ExternalLinkType>>,
      default: () => [],
    },
  },
})
</script>

<style scoped lang="scss">
.external-confirmation-section {
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding-right: 16px;
  padding-left: 16px;
  text-align: center;

  &__title {
    font-size: 17px;
    font-weight: 500;
    color: $black;
    letter-spacing: 0.04em;
  }

  &__message {
    font-size: 13px;
    font-weight: 500;
    color: $gray75;
    letter-spacing: 0.04em;
  }

  &__list {
    display: flex;
    gap: 24px;
    flex-direction: column;
  }

  &__item {
    opacity: 0.8;

    &Link {
      color: $black80;
      text-decoration-color: rgba($black80, 0.5);
    }
  }
}
</style>
